var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{attrs:{"help":"HelpProfileImage","helpcontext":{
        type: 'Agent',
    }}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Agent Profile Photo")])])
}
var staticRenderFns = []

export { render, staticRenderFns }